<div id="move-unit">

    <h1>Mover unidad a otro curso</h1>

    <div id="selected-unit" class="mt-3">
        <p><b>Unidad seleccionada:</b> {{ unitName }}</p>
    </div>

    <div id="destination-course" class="mt-3">
        <p class="fw-bold">Selecciona un curso de destino:</p>

        <div id="destination-course-category-select" class="mt-3">
            <p class="fw-bold">Categoría del curso de destino:</p>
            <select class="form-control" [(ngModel)]="destinationCategoryId" (ngModelChange)="getCategoryCourses(destinationCategoryId)">
                <option value="-1">Seleccione una categoría...</option>
                <option *ngFor="let category of categories" [value]="category.id">
                    {{ category.name }}
                </option>
            </select>
        </div>

        <div id="destination-course-select" class="mt-3" *ngIf="categoryCourses.length > 0">
            <p class="fw-bold">Curso de destino:</p>
            <select class="form-control" [(ngModel)]="destinationCourseId">
                <option value="-1" disabled>Seleccione un curso...</option>
                <option *ngFor="let c of categoryCourses" [value]="c.id" [class.d-none]="c.id == courseId">
                    {{ c.name }}
                </option>
            </select>
        </div>
    </div>

    <div id="move-unit-buttons" class="mt-4">
        <button class="btn btn-success me-3" (click)="moveUnit()">
            <i class="fa fa-arrow-right"></i>
            <span>Mover unidad</span>
        </button>
        <button class="btn btn-danger me-3" (click)="close()">
            <i class="fa fa-times"></i>
            <span>Cancelar</span>
        </button>
    </div>

    <div id="move-unit-status" class="mt-3" *ngIf="movingUnit || moveUnitSuccess || moveUnitError">
        <div id="move-unit-loading" *ngIf="movingUnit">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Moviendo unidad, espere por favor...</span>
        </div>
        <div id="move-unit-success" class="text-success" *ngIf="moveUnitSuccess">
            <i class="fa fa-check"></i>
            <span>La unidad se ha movido correctamente.</span>
        </div>
        <div id="move-unit-error" class="text-danger" *ngIf="moveUnitError">
            <i class="fa fa-times"></i>
            <span>Ha habido un error al mover la unidad. Por favor, inténtelo de nuevo.</span>
        </div>
    </div>

</div>